angular.module('aq.filters.formatters')
.filter("plus", function() {
    return function(input) {
        return input > 0 ? ('+' + input) : input;
    }
});